import { useQuery } from '@tanstack/react-query'
import { t } from 'app/i18l'
import { useServer } from 'app/server/context'
import { nativeApplicationVersion } from 'expo-application'
import Constants from 'expo-constants'
import { BaseHomeItem, SummaryItem } from 'home/types'
import { Platform } from 'react-native'
import { RetryQuery } from 'shared/queries/utils'
import url from 'url'
import { useUser } from 'users/queries/detail'
import keys from './shared/keys'
import { makeErrorHomeItem, makeSuccessHomeItem } from './shared/utils'

export function useUpdateApp(retryQuery?: RetryQuery) {
  const { server } = useServer()
  const { data: user } = useUser()
  const pathname = '/v2/recommended_version_check'
  const queryParams: { [key: string]: string | null | undefined } = {}
  queryParams['app_version'] = nativeApplicationVersion
  const queryUrl = url.format({ pathname, query: queryParams })

  return useQuery({
    queryKey: keys.updateApp,
    queryFn: fetchUpdateApp,
    enabled: !!user,
    retry: retryQuery ?? false,
  })

  async function fetchUpdateApp() {
    const response = await server.get<boolean>(queryUrl)
    return response
  }
}
export function useUpdateAppHomeItem() {
  const baseItem: BaseHomeItem = {
    backgroundColor: '#FFE2B3',
    route: { name: 'update_app' },
    params: {
      storeUrl:
        Platform.OS === 'android'
          ? Constants.expoConfig?.extra?.storeLinks?.playStoreUrl
          : Constants.expoConfig?.extra?.storeLinks?.appStoreUrl,
    },
    title: t('updateAvailable'),
  }
  const {
    data: isUpdateNeeded,
    isError: isUpdateNeededError,
    error: updateNeededError,
  } = useUpdateApp()
  if (isUpdateNeededError) {
    return makeErrorHomeItem(baseItem, updateNeededError)
  }

  if (!isUpdateNeeded) {
    return
  }

  const summaryItems: SummaryItem[] = [
    {
      title: t('updateAvailable'),
      description: t('newAppVersion'),
    },
  ]
  return makeSuccessHomeItem(baseItem, summaryItems)
}
